<!-- @format -->

<template>
    <span
        class="gst-promoted-card-chip u-position-absolute d-flex justify-center align-center"
        :class="[fullWidth ? 'full-width' : 'fit-content']"
        :style="[styleVariables, promotedCardChipStyle]">
        <img
            v-if="fullWidth && iconUrl"
            class="gst-promoted-card-chip--image"
            :src="iconUrl"
            alt="image" />
        <span class="pl-2 pr-2">
            {{ $t('_common:terms.preferredPartner') }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'PromotedCardChip',
    props: {
        backgroundColor: {
            type: String,
            default: null,
        },
        fontColor: {
            type: String,
            default: null,
        },
        iconUrl: {
            type: String,
            default: null,
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        styleVariables() {
            return {
                '--promoted-card-chip-bg': this.backgroundColor,
                '--promoted-card-chip-color': this.fontColor,
            };
        },
        promotedCardChipStyle() {
            return {
                top: this.fullWidth ? (this.$vuetify.breakpoint.mdAndUp ? 0 : '8px') : null,
            };
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-promoted-card-chip {
    right: 0;
    line-height: 17px;
    padding: theme-spacing(1);
    border: 1px solid var(--promoted-card-chip-bg, theme-color('default-promoted-bg'));
    background-color: var(--promoted-card-chip-bg, theme-color('default-promoted-bg'));
    color: var(--promoted-card-chip-color, theme-color('default-promoted-color'));
    font-size: font-size('xxxs');
    font-weight: font-weight('large');
    text-transform: uppercase;
    pointer-events: none;

    &.fit-content {
        height: 17px;
        width: fit-content;
        border-radius: 0 3px;

        @include mobile-only {
            border-radius: 0 0 0 3px;
        }
    }

    &.full-width {
        height: 24px;
        width: 100%;
        border-radius: 3px 3px 0 0;

        @include mobile-only {
            border-radius: 0;
        }
    }

    .gst-promoted-card-chip--image {
        height: 16px;
    }
}
</style>
